import { render, staticRenderFns } from "./SupportCreateDialog.vue?vue&type=template&id=6bc50db8&scoped=true"
import script from "./SupportCreateDialog.vue?vue&type=script&lang=js"
export * from "./SupportCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./SupportCreateDialog.vue?vue&type=style&index=0&id=6bc50db8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc50db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc50db8')) {
      api.createRecord('6bc50db8', component.options)
    } else {
      api.reload('6bc50db8', component.options)
    }
    module.hot.accept("./SupportCreateDialog.vue?vue&type=template&id=6bc50db8&scoped=true", function () {
      api.rerender('6bc50db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SupportCreateDialog.vue"
export default component.exports